import * as React from "react";

const FacilityOperationsIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            height="120"
            viewBox="0 0 211.862 116.295"
        >
            <defs>
                <clipPath id="clip-path">
                    <rect id="Rectangle_4849" data-name="Rectangle 4849" width="66.394" height="201.545" fill="none" />
                </clipPath>
            </defs>
            <g
                id="Group_2501"
                data-name="Group 2501"
                transform="matrix(-0.259, -0.966, 0.966, -0.259, 17.184, 116.295)"
            >
                <g id="Group_2500" data-name="Group 2500" clipPath="url(#clip-path)">
                    <path
                        id="Path_4552"
                        data-name="Path 4552"
                        d="M31.807,57.459c1.564-9.482,3.042-18.44,2.766-24.971-.405-9.512-3.82-11.924-6.339-12.535A32.939,32.939,0,0,1,29.755,29.3C30.1,36.4,28.3,45.939,26.4,56.039c-1.257,6.67-2.61,13.874-3.5,21.167.293,2.865.512,5.753.646,8.641h4.5c.239-3.825.673-7.7,1.22-11.534.721-5.818,1.66-11.514,2.54-16.854"
                        fill="#fff"
                    />
                    <path
                        id="Path_4553"
                        data-name="Path 4553"
                        d="M42.508,32.153C41.96,19.219,35.991,11.8,26.13,11.8c-9.622,0-15.638,7.046-16.508,19.331-.522,7.393,1.009,17.016,2.63,27.2A259.371,259.371,0,0,1,15.6,85.846h5.06a260.627,260.627,0,0,0-3.418-28.305c-1.575-9.893-3.061-19.238-2.579-26.053.472-6.676,2.845-14.632,11.465-14.632,8.82,0,11.028,8.435,11.327,15.509.289,6.829-1.211,15.928-2.8,25.562a260.824,260.824,0,0,0-3.549,27.919h5.061a259.555,259.555,0,0,1,3.477-27.1c1.631-9.9,3.174-19.249,2.863-26.6"
                        fill="#fff"
                    />
                    <path
                        id="Path_4554"
                        data-name="Path 4554"
                        d="M7.33,85.847h5.381A258.875,258.875,0,0,0,9.4,58.789c-.611-3.837-1.21-7.6-1.693-11.2-1.231-7.3-2.086-13.979-1.662-19.193.69-8.56,2.8-12.936,7.357-14.474a17.423,17.423,0,0,1,12.585-5,18.727,18.727,0,0,0-8.006-1.6C1.794,7.319.584,22.281.128,27.913-.508,35.775,1.341,45.938,3.3,56.7,4.952,65.805,6.788,75.936,7.33,85.847"
                        fill="#fff"
                    />
                    <path
                        id="Path_4555"
                        data-name="Path 4555"
                        d="M24.563,5.746A8.623,8.623,0,0,1,26.5,5.517a10.088,10.088,0,0,1,9.822,6.336,19.611,19.611,0,0,1,7.349,10.282c0-.619-.009-1.229-.031-1.825C43.187,7.783,36.62,0,26.5,0A15.179,15.179,0,0,0,15.526,4.99c.787-.071,1.6-.121,2.456-.121a23.377,23.377,0,0,1,6.581.877"
                        fill="#fff"
                    />
                    <path
                        id="Path_4556"
                        data-name="Path 4556"
                        d="M20.611,116.755q.1-1.748.148-3.489H19.275a28.556,28.556,0,0,0,1.336,3.489"
                        fill="#fff"
                    />
                    <path
                        id="Path_4557"
                        data-name="Path 4557"
                        d="M31,113.266c.185,5.383.745,10.845,1.464,16.185,1.78,1.164,3.653,2.267,5.588,3.376a177.506,177.506,0,0,1-1.994-19.561Z"
                        fill="#fff"
                    />
                    <path
                        id="Path_4558"
                        data-name="Path 4558"
                        d="M23.645,113.266c-.073,2.616-.229,5.238-.448,7.849a30.387,30.387,0,0,0,6.064,6.071,138.1,138.1,0,0,1-1.337-13.92Z"
                        fill="#fff"
                    />
                    <path
                        id="Path_4559"
                        data-name="Path 4559"
                        d="M25.988,192.63a17.423,17.423,0,0,1-12.585-5c-4.553-1.538-6.667-5.914-7.357-14.472-.424-5.217.431-11.9,1.662-19.195.483-3.605,1.082-7.363,1.693-11.2,1.017-6.4,2.12-13.331,2.8-20.294a38.814,38.814,0,0,1-3.388-9.2H7.434C7.092,123.943,5.088,134.994,3.3,144.85c-1.956,10.759-3.8,20.922-3.169,28.784.456,5.632,1.666,20.6,17.854,20.6a18.741,18.741,0,0,0,8.006-1.6"
                        fill="#fff"
                    />
                    <path
                        id="Path_4560"
                        data-name="Path 4560"
                        d="M19.111,131.672a38,38,0,0,1-4.439-5.188C14,132.245,13.1,137.91,12.253,143.211c-1.621,10.188-3.153,19.81-2.63,27.2.87,12.284,6.886,19.329,16.508,19.329,9.861,0,15.83-7.417,16.378-20.35.28-6.617-.944-14.86-2.381-23.66-1.7-1.054-3.51-2.091-5.409-3.172-.085-.05-.173-.1-.26-.15.066.4.133.807.2,1.205,1.59,9.634,3.09,18.736,2.8,25.563-.3,7.076-2.507,15.51-11.327,15.51-8.621,0-10.994-7.956-11.465-14.633-.483-6.815,1-16.158,2.579-26.051.628-3.945,1.287-8.089,1.866-12.334"
                        fill="#fff"
                    />
                    <path
                        id="Path_4561"
                        data-name="Path 4561"
                        d="M16.884,113.266h-5.73c3.834,15.405,14.85,21.7,24.7,27.311,9.476,5.4,17.662,10.071,19.018,21.881l5.5-.631c-1.676-14.6-11.895-20.426-21.777-26.061-9.316-5.311-18.181-10.376-21.71-22.5"
                        fill="#fff"
                    />
                    <path
                        id="Path_4562"
                        data-name="Path 4562"
                        d="M36.323,189.692a10.085,10.085,0,0,1-9.821,6.337,8.632,8.632,0,0,1-1.939-.229,23.381,23.381,0,0,1-6.581.875c-.858,0-1.669-.049-2.456-.121a15.178,15.178,0,0,0,10.976,4.99c10.118,0,16.685-7.782,17.139-20.307.022-.6.031-1.207.032-1.826a19.615,19.615,0,0,1-7.35,10.281"
                        fill="#fff"
                    />
                    <path
                        id="Path_4563"
                        data-name="Path 4563"
                        d="M28.234,181.594c2.52-.612,5.935-3.023,6.339-12.537.276-6.529-1.2-15.485-2.766-24.969-.191-1.163-.386-2.349-.581-3.544-2.157-1.269-4.356-2.642-6.506-4.192.546,3.131,1.121,6.2,1.678,9.156,1.9,10.1,3.7,19.637,3.357,26.745a32.908,32.908,0,0,1-1.521,9.341"
                        fill="#fff"
                    />
                    <rect
                        id="Rectangle_4846"
                        data-name="Rectangle 4846"
                        width="33.457"
                        height="5.053"
                        transform="translate(5.35 104.678)"
                    />
                    <rect
                        id="Rectangle_4847"
                        data-name="Rectangle 4847"
                        width="33.457"
                        height="5.052"
                        transform="translate(5.35 96.68)"
                    />
                    <rect
                        id="Rectangle_4848"
                        data-name="Rectangle 4848"
                        width="33.457"
                        height="5.053"
                        transform="translate(5.35 88.68)"
                    />
                    <path
                        id="Path_4564"
                        data-name="Path 4564"
                        d="M64.453,181.685l-10.025.921a2.136,2.136,0,0,1-2.322-1.932l-1.334-14.525a2.136,2.136,0,0,1,1.931-2.322l10.025-.921a2.136,2.136,0,0,1,2.323,1.932l1.334,14.525a2.137,2.137,0,0,1-1.932,2.322"
                        fill="#fff"
                    />
                    <path
                        id="Path_4565"
                        data-name="Path 4565"
                        d="M56.3,190.474h0a.888.888,0,0,1-.963-.8l-.8-8.662a.886.886,0,0,1,1.765-.162l.8,8.662a.888.888,0,0,1-.8.963"
                        fill="#fff"
                    />
                    <path
                        id="Path_4566"
                        data-name="Path 4566"
                        d="M64.142,189.754l-.155.014a.964.964,0,0,1-1.045-.87l-.782-8.51a.965.965,0,0,1,.87-1.046l.154-.014a.965.965,0,0,1,1.046.87l.782,8.51a.965.965,0,0,1-.87,1.046"
                        fill="#fff"
                    />
                    <path
                        id="Path_4567"
                        data-name="Path 4567"
                        d="M59.967,187.88h0a.888.888,0,0,1-.963-.8l-.8-8.662a.886.886,0,0,1,1.765-.162l.8,8.662a.888.888,0,0,1-.8.963"
                        fill="#fff"
                    />
                </g>
            </g>
        </svg>
    );
};

export default React.memo(FacilityOperationsIcon);
